
export const MAIN_LEARNING_CARD_DATA = [
  {
    learningCardBy: "Paige Turner",
    dateSpan: "05",
    date: "January 2023",
    hits: 15,
    language: "Java Language",
  },
  {
    learningCardBy: "Petey Cruiser",
    dateSpan: "10",
    date: "March 2023",
    hits: 36,
    language: "Web Development",
  },
];

export const IMAGE_PATH = [
  {
    src: 3,
    text: "This course is designed to start you on a path toward future studies in web development and design.",
  },
  {
    src: 1,
    text: "A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn",
  },
  {
    src: 4,
    text: "User interface design (UI) is the design for machines and software, such as mobile devices, computers.",
  },
  {
    src: 2,
    text: "Spoken English Courses are pursued by candidates from all levels to improve their communication skills.",
  },
  {
    src: 4,
    text: "This course is designed to start you on a path toward future studies in web development and design.",
  },
  {
    src: 3,
    text: "A Web Development course belongs to the field of Computer Science and IT. It enables students to learn",
  },
];

export const LEARNING_FILTER_DATA = ["Accounting", "Design", "Development", "Management"];

export const DURATION_DATA = ["0-50 hours", "50-100 hours", "100+ hours"];

export const PRICE_CHECH_DATA = ["All Courses", "Paid Courses", "Free Courses"];

export const STATUS_CHECK_DATA = ["Registration", "Progress", "Completed"];

export const DESIGN_CATEGORT_DATA = [
  { learningHeading: "UI Design", badgeNumber: 28 },
  { learningHeading: "UX Design", badgeNumber: 35 },
  { learningHeading: "Interface Design", badgeNumber: 17 },
  { learningHeading: "User Experience", badgeNumber: 26 },
];

export const DEVELOPMENT_DATA = [
  { DevelopmentHeading: "Frontend Development", badgeNumber: 48 },
  { DevelopmentHeading: "Backend Development", badgeNumber: 19 },
];

export const UPCOMING_COURSE_DATA = [
  { courseHeading: "UX Development", courseDate: 18, courseMonth: "Dec", courseTeam: "Development Team" },
  { courseHeading: "Business Analyst", courseDate: 28, courseMonth: "Dec", courseTeam: "Analyst Team" },
  { courseHeading: "Web Development", courseDate: 5, courseMonth: "Jan", courseTeam: "Designer" },
];